import React from 'react';
import PropTypes from 'prop-types';
import SurveyProp from '../../../survey/propTypes/surveyProp';
import SurveyDetails from '../../../survey/SurveyDetails';
import { useLoader } from '../../../../services/customHooks';

export default function JourneyContentSurvey({
  survey: surveyParam,
  contextId,
  onChange,
  onSkipStep,
}) {
  let url = `/survey/${surveyParam._id}/data`;
  if (contextId) {
    url += `?context=${contextId}`;
  }
  const { data: survey } = useLoader(url, 'error_fetchStepSurvey', surveyParam);
  return (
    <>
      <SurveyDetails
        survey={survey}
        contextId={contextId}
        redirectOnSubmit={false}
        onDone={onChange}
        onSkipStep={onSkipStep}
      />
    </>
  );
}

JourneyContentSurvey.propTypes = {
  survey: PropTypes.shape(SurveyProp.propType).isRequired,
  contextId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSkipStep: PropTypes.func,
};

JourneyContentSurvey.defaultProps = {
  contextId: null,
  onSkipStep: null,
};
